<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Nova Mensagem' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <div class="gradient-extendido">
      <ion-grid [fixed]="true">
        <ion-row class="align-items-center">
          <ion-col size="auto" class="label-col">
            <strong>{{ 'Enviar para:' | translate }}</strong>
          </ion-col>

          <ion-col size="8" class="chip-col">
            <ng-container *ngIf="pessoa?.id; else addPessoa">
              <ion-chip class="custom-chip" (click)="changeVincular(false)">
                <ion-avatar class="chip-avatar">
                  <img [src]="pessoa.foto | image:' '" />
                </ion-avatar>

                <ion-label class="chip-label"> {{ pessoa.nome }} </ion-label>

                <i class="fa-regular fa-xmark-large chip-close-icon"></i>
              </ion-chip>
            </ng-container>

            <ng-template #addPessoa>
              <div class="add-pessoa-button" (click)="changeVincular(true)">
                <ion-icon name="add" slot="icon-only"></ion-icon>
              </div>
            </ng-template>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div class="remove-border remove-card">
      <ion-card-content>
        <ion-list>
          <ion-item class="switcher-item">
            <ion-label
              position="stacked"
              style="font-size: 14px; font-weight: bold"
            >
              {{'Título' | translate}}
              <span class="danger">*</span>
            </ion-label>

            <ion-input
              type="text"
              formControlName="titulo"
              style="font-size: 14px"
              placeholder="{{'Título' | translate}}"
            ></ion-input>
          </ion-item>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.titulo">
              <div
                class="error-message"
                *ngIf="
                  validations_form.get('titulo')?.hasError(validation.type) &&
                  (validations_form.get('titulo')?.dirty ||
                  validations_form.get('titulo')?.touched)
                "
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>

          <ion-item class="switcher-item">
            <ion-label
              position="stacked"
              style="font-size: 14px; font-weight: bold"
            >
              {{'Mensagem' | translate}}
              <span class="danger">*</span>
            </ion-label>
            <ion-textarea
              rows="5"
              type="text"
              formControlName="mensagem"
              style="font-size: 13px"
              placeholder="{{'Mensagem' | translate}}"
            ></ion-textarea>
          </ion-item>

          <div class="validation-errors">
            <ng-container
              *ngFor="let validation of validation_messages.mensagem"
            >
              <div
                class="error-message"
                *ngIf="
                  validations_form.get('mensagem')?.hasError(validation.type) &&
                  (validations_form.get('mensagem')?.dirty ||
                  validations_form.get('mensagem')?.touched)
                "
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>

          <div class="down">
            <ion-button
              expand="block"
              class="btn-success"
              type="submit"
              [disabled]="!validations_form.valid"
            >
              {{'Enviar Mensagem' | translate}}
            </ion-button>
          </div>
        </ion-list>
      </ion-card-content>
    </div>
  </form>
</ion-content>
